import { render, staticRenderFns } from "./F104.vue?vue&type=template&id=8a2be652&scoped=true"
import script from "./F104.vue?vue&type=script&lang=js"
export * from "./F104.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=8a2be652&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2be652",
  null
  
)

export default component.exports